import React from 'react'
import { ELEMENT_TYPES } from 'cg/components/documents/editor/slate/types'
import { Transforms } from 'vendor/slate'
import { useSelected, useFocused } from 'vendor/slate-react'
import { v4 as uuidv4 } from 'uuid'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'
import { deepGet } from 'cg/helpers'
import { useQuery } from '@apollo/client'
import { DocumentCollaborator } from 'cg/components/documents/editor/slate/operations.graphql'

export const withMentions = editor => {
  const { isInline, isVoid } = editor

  editor.isInline = element => (element.type === ELEMENT_TYPES.mention ? true : isInline(element))

  editor.isVoid = element => (element.type === ELEMENT_TYPES.mention ? true : isVoid(element))

  return editor
}

export const insertMention = (editor, user, addMention) => {
  const uuid = uuidv4()
  const mention = {
    type: ELEMENT_TYPES.mention,
    userId: user.id,
    id: uuid,
    uuid,
    children: [{ text: user.username, uuid, parent: { type: ELEMENT_TYPES.mention } }]
  }
  Transforms.insertNodes(editor, mention)
  Transforms.move(editor)

  addMention(mention)
}

export const Mention = ({ attributes, children, element }) => {
  const { documentId, username, workspacePath } = useParams()
  const { hash } = window.location
  const { userId, id } = element
  const mentionRef = React.useRef(null)

  const { data } = useQuery(DocumentCollaborator, {
    variables: { username, workspacePath, documentId, userId },
    skip: !userId
  })

  const userName = deepGet(data, 'myCurrentWorkspace.document.collaborator.user.username')

  const selected = useSelected()
  const focused = useFocused()

  React.useEffect(() => {
    if (hash === `#${id}`) {
      mentionRef.current.scrollIntoView({ behavior: 'smooth' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <MentionContainer
      {...attributes}
      ref={mentionRef}
      highlight={hash === `#${id}`}
      contentEditable={false}
      id={id}
      selected={selected}
      focused={focused}
    >
      @{userName}
      {children}
    </MentionContainer>
  )
}


const MentionContainer = styled.span`
  padding: 2px 5px;
  margin: 0 4px;
  vertical-align: baseline;
  display: inline-block;
  border-radius: 4px;
  background-color: ${props => props.theme.hoverBg};
  color: ${props => props.theme.linkColor};
  font-size: 0.85em;
  ${props =>
    props.highlight &&
    `
  @keyframes highlight {
    from {
      background-color: ${props.theme.mark};
    }
    to {
      background-color: ${props.theme.hoverBgLightestInverse};
    }
  }
  animation: highlight 5000ms ease-out;
`}
`
